import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DebugLoggerService } from '../services/debug-logger.service';

@Injectable({
  providedIn: 'root'
})
export class UserProperty {

  private _debugLogger = inject(DebugLoggerService);

  userDashboards: any;
  dataOwnerId: any;

  private _realUser: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public realUser: Observable<any> = this._realUser.asObservable();

  private _userParty: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public userParty: Observable<any> = this._userParty.asObservable();

  private _userCompanies: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public userCompanies: Observable<any> = this._userCompanies.asObservable();

  private _selectedCompany: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public selectedCompany: Observable<any> = this._selectedCompany.asObservable();

  private _editedDashboard: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public editedDashboard: Observable<any> = this._editedDashboard.asObservable();

  constructor() { }

  public setRealUser(realUser: any): void {
    this._realUser.next(realUser);
    this._debugLogger.logState('UserProperty', 'realUser', realUser);
  }
  public get realUserModel(): any {
    return this._realUser.getValue();
  }

  public setUserParty(userParty: any): void {
    this._userParty.next(userParty);
    this._debugLogger.logState('UserProperty', 'userParty', userParty);
  }
  public get userPartyModel(): any {
    return this._userParty.getValue();
  }

  public setUserCompanies(userCompanies: any): void {
    this._userCompanies.next(userCompanies);
    this._debugLogger.logState('UserProperty', 'userCompanies', userCompanies);
  }
  public get userCompaniesList(): any {
    return this._userCompanies.getValue();
  }

  public setSelectedCompany(selectedCompany: any): void {
    this._selectedCompany.next(selectedCompany);
    this._debugLogger.logState('UserProperty', 'selectedCompany', selectedCompany);
  }
  public get userSelectedCompany(): any {
    return this._selectedCompany.getValue();
  }

  public setEditedDashboard(editedDashboard: any): void {
    this._editedDashboard.next(editedDashboard);
    this._debugLogger.logState('UserProperty', 'editedDashboard', editedDashboard);
  }
  public get userEditedDashboard(): any {
    return this._editedDashboard.getValue();
  }
}
